import { MODULE_NAME } from './const';
import state from './state';

import { getActionsDeclarations, buildActions } from '../../utils/widget-editor-module-generator/actions-generator';

export const {
	reset,
	initWidgetFields,
	setEditorState,
	setWidgetId,
	setFields,
	duplicateField,
	deleteWidgetField,
	setEditField,
	updateWidgetFieldEdit,
	updateFieldsOrder,
	addField,
	saveWidget,
	saveWidgetDebounce,
	saveWidgetAPI,
	saveAndCloseWidget,
	setWidgetTitle,
	setWidgetMetadata,
	setWidgetOption,
	setWidgetStyle,
	editFirstField,
	createSourceFieldForEditField,
	moveWidgetFieldConfiguration,
	syncWidgetEditorWithWidgetsStore,
} = getActionsDeclarations(MODULE_NAME);

const actions = buildActions(MODULE_NAME, state);

export default actions;
